import { render, staticRenderFns } from "./CommercialClaimForm.vue?vue&type=template&id=05ca42b9&scoped=true&"
import script from "./CommercialClaimForm.vue?vue&type=script&lang=js&"
export * from "./CommercialClaimForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca42b9",
  null
  
)

export default component.exports